/**
 * @param {jsonForm} data
 * @returns {string}
 * @constructor
 */
export function TempCartInfo(data) {
  const container = `
       ${row(
    rowName('Фамилия и имя', data.name),
    liChild(data.name),
  )}
       ${row(
    rowName('Телефон', data.phone),
    liChild(data.phone),
  )}
        ${row(
    rowName('E-mail', data.email),
    liChild(data.email),
  )}
        ${row(
    rowName('VIN номер', data.vin),
    liChild(data.vin),
  )}
        ${row(
    rowName('Комментарий', data.comment_for_auto),
    liChild(data.comment_for_auto),
  )}
        ${row(
    rowName('Способ доставки', data.delivery_method),
    liChild(translateDelivery(data.delivery_method)),
  )}
        ${row(
    rowName('Адрес', data.city),
    getAddressInfo(data),
  )}
        ${row(
    rowName('Код домофона', data.intercom_code),
    liChild(data.intercom_code),
  )}
        ${row(
    rowName('Удобное время', data.date),
    liChild(data.date),
  )}
  `;
  return container;
}

/**
 *
 * @param {string} val
 * @param {string|null} param
 * @returns {string}
 */
function rowName(val, param) {
  if (param !== undefined && param !== null && param !== '') {
    return `<li>
              <strong>
                  ${val}
              </strong>
          </li>`;
  }
  return '';
}

function row(name, value) {
  const str = `<div class="row">
            <div class="col-6 col-md-3">
                ${name}
            </div>
            <div class="col-6 col-md-8">
               ${value}
            </div>
         </div>`;
  return (value) ? str : '';
}

/**
 * @param {string|null} val
 * @returns {string}
 */
function liChild(val) {
  if (val !== undefined && val !== null && val !== '') {
    return `<li>${val}</li>`;
  }
  return '';
}

function getAddressInfo(data) {
  const arr = [
    notNullStr('', data.index),
    notNullStr('', data.region),
    notNullStr('г. ', data.city),
    notNullStr('ул. ', data.street),
    notNullStr('дом ', data.building),
    notNullStr('этаж ', data.floor),
    notNullStr('подъезд ', data.flatRoom),
    notNullStr('кв. / оф. ', data.apartment),
  ];

  return arr.filter(Boolean).join(', ');
}

/**
 * @param {string} str
 * @param {string|null} str2
 * @returns {string}
 */
function notNullStr(str, str2) {
  if (str2 !== undefined && str2 !== null && str2 !== '') {
    return str + str2;
  }
  return '';
}

/**
 * @param {string} str
 * @returns {string}
 */
function translateDelivery(str) {
  switch (str) {
    case '1':
      return 'Самовывоз из магазина в Москве';
    case '2':
      return 'Курьером по Москве и ближайшему Подмосковью';
    case '3':
      return 'Доставка по всей России';
    case '4':
      return 'Доставка СДЭК';
    default:
      return '';
  }
}
